import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ show, title, message, confirmText = 'Confirm', cancelText = 'Cancel', onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <div className="confirm-modal-content">
          <h3 className="confirm-modal-title">{title || 'تأكيد العملية'}</h3>
          <p className="confirm-modal-subtitle">{title ? 'Confirmation' : 'Confirm Action'}</p>
          {message && <p className="confirm-modal-message">{message}</p>}
        </div>
        <div className="confirm-modal-actions">
          <button className="confirm-modal-btn confirm-modal-btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirm-modal-btn confirm-modal-btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

